"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Translations = require("react-platform-components/dist/Translations");
var _styles = require("@material-ui/core/styles");
var _reactRedux = require("react-redux");
var _index = require("../../config/index");
var _excluded = ["filteredHeadColumns", "appliedFilter", "setAppliedFilter"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1
    },
    tableSortLabel: {
      "&:hover, &:focus": {
        color: "#fff",
        "& .MuiTableSortLabel-icon": {
          opacity: "0.85 !important"
        }
      }
    },
    active: {
      color: "#fff !important",
      fontWeight: "bold"
    },
    icon: {
      color: "#fff !important"
    }
  };
});
var StyledTableCell = (0, _styles.withStyles)(function (theme) {
  return {
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      fontSize: "14px"
    }
  };
})(_core.TableCell);
var CustomTableHead = function CustomTableHead(_ref) {
  var _appliedFilter$_sort, _appliedFilter$_sort2;
  var filteredHeadColumns = _ref.filteredHeadColumns,
    appliedFilter = _ref.appliedFilter,
    setAppliedFilter = _ref.setAppliedFilter,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var order = (_appliedFilter$_sort = appliedFilter._sort) !== null && _appliedFilter$_sort !== void 0 && _appliedFilter$_sort.includes("-") ? "desc" : "asc";
  var orderBy = (_appliedFilter$_sort2 = appliedFilter._sort) === null || _appliedFilter$_sort2 === void 0 ? void 0 : _appliedFilter$_sort2.replace("-", "");
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return {
        user: state.auth.user
      };
    }),
    user = _useSelector.user;
  var handleRequestSort = function handleRequestSort(property) {
    var isAsc = orderBy === property && order === "asc";
    // if the user clicks on the same column, we reverse the order of the sort
    // if the user clicks again for the third time on the same column, we remove the sort
    // if the user clicks on a different column, we sort by the new column
    var sortingBy = orderBy === property && order === "desc" ? undefined : "".concat(isAsc ? "-" : "").concat(property);
    var newAppliedFilter = _objectSpread({}, appliedFilter);
    if (sortingBy) {
      newAppliedFilter._sort = sortingBy;
    } else {
      delete newAppliedFilter._sort;
    }
    setAppliedFilter(newAppliedFilter);
  };
  return /*#__PURE__*/_react.default.createElement(_core.TableHead, null, /*#__PURE__*/_react.default.createElement(_core.TableRow, null, filteredHeadColumns.map(function (_ref2) {
    var label = _ref2.label,
      value = _ref2.value,
      specificities = _ref2.specificities,
      sortable = _ref2.sortable,
      isAbleToShow = _ref2.isAbleToShow;
    if (!isAbleToShow) return null;
    if (value === "specificity") {
      return specificities.map(function (_ref3) {
        var label = _ref3.label,
          value = _ref3.value;
        return /*#__PURE__*/_react.default.createElement(StyledTableCell, {
          style: {
            minWidth: "".concat(label.length + 2, "ch")
          },
          key: value
        }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: label,
          defaultMessage: label
        }));
      });
    } else if (!sortable) {
      return /*#__PURE__*/_react.default.createElement(StyledTableCell, {
        style: {
          minWidth: "".concat(props.intl.formatMessage({
            id: label,
            defaultMessage: label
          }).length + 2, "ch")
        },
        key: value
      }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: label,
        defaultMessage: label
      }));
    } else {
      return /*#__PURE__*/_react.default.createElement(StyledTableCell, {
        style: {
          minWidth: "".concat(props.intl.formatMessage({
            id: label,
            defaultMessage: label
          }).length + 2, "ch")
        },
        sortDirection: orderBy === value ? order : false,
        key: value
      }, /*#__PURE__*/_react.default.createElement(_core.TableSortLabel, {
        active: orderBy === value,
        direction: orderBy === value ? order : "asc",
        onClick: function onClick() {
          return handleRequestSort(value);
        },
        classes: {
          root: classes.tableSortLabel,
          active: classes.active,
          icon: classes.icon
        }
      }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: label,
        defaultMessage: label
      }), orderBy === value ? /*#__PURE__*/_react.default.createElement("span", {
        className: classes.visuallyHidden
      }, order === "desc" ? "sorted descending" : "sorted ascending") : null));
    }
  }), !user.roles.some(function (item) {
    return _index.HIDE_EDIT_PRODUCT_MENU_BY_USER_ROLES.includes(item);
  }) && /*#__PURE__*/_react.default.createElement(StyledTableCell, null)));
};
var _default = (0, _Translations.injectIntl)(CustomTableHead);
exports.default = _default;